import { TriggerType } from '@katanaperps/katana-perps-sdk';
import { useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';

import { getMarketTickerFromCache } from '#/api/queries/tickersQueries';
import { useInterval } from '#/components/hooks';
import { getBestPriceFromDisplayedOrderbook } from '#/components/orders/orderBook/orderBookService';
import { isTriggerTakeProfit } from '#/components/orders/orderUtil';

import { TwoColumnData } from './layout';

export function DevTrigger({
  triggerPrice,
  triggerType,
  market,
}: {
  triggerPrice: number;
  triggerType: Extract<TriggerType, 'last' | 'index'>;
  market: string | undefined;
}) {
  const queryClient = useQueryClient();
  const [state, setState] = useState<
    { buy: boolean; sell: boolean } | undefined
  >();
  const updateTimeSec = 3;
  useInterval(() => {
    const bestBid = getBestPriceFromDisplayedOrderbook('bid');
    const bestAsk = getBestPriceFromDisplayedOrderbook('ask');
    // Same point-in-time cache read as order submit (websocket synced by
    // the dashboard ticker subscription)
    const indexPrice =
      getMarketTickerFromCache(queryClient, market)?.indexPrice || undefined;
    try {
      const buyTriggerTakeProfit = isTriggerTakeProfit({
        side: 'buy',
        triggerType,
        triggerPrice,
        indexPrice,
        bestAsk,
        bestBid,
      });
      const sellTriggerTakeProfit = isTriggerTakeProfit({
        side: 'sell',
        triggerType,
        triggerPrice,
        indexPrice,
        bestAsk,
        bestBid,
      });
      setState({ buy: buyTriggerTakeProfit, sell: sellTriggerTakeProfit });
    } catch (error) {
      console.debug(error);
      setState(undefined);
    }
  }, updateTimeSec * 1000);
  return (
    <>
      <TwoColumnData
        label="Trigger Type"
        buySide={!state ? '-' : state.buy ? 'TAKE PROFIT' : 'STOP LOSS'}
        sellSide={!state ? '-' : state.sell ? 'TAKE PROFIT' : 'STOP LOSS'}
      />
      <small>Updated once per {updateTimeSec} secs</small>
      <br />
      <br />
    </>
  );
}
